module.exports = __webpack_public_path__ + "img/snackDownload4.4c0251a.png";